import React, { Component } from 'react';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Translate, Localize } from 'react-redux-i18n';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { omit } from 'lodash';

import { DEFAULT_ERROR, UI_HEIGHT } from '../Common/constants';
import checkPermission from '../Common/permissions';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { isOLG, isVAK } from '../../actions/root_url';
import { MFG_ORDER_UPLOAD, RECEIVE_QC_URL } from '../../actions/url';

class SetQualityControlModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      rows: [],
      selectedRow: {},
      isLoading: false,
    }
  }

  componentDidMount() {
    this.setState({
      rows: this.props.rows.map(row => ({
        ...row,
        ExcellentQuantity: row.ExcellentQuantity === null ? row.RcvQuantity : row.ExcellentQuantity,
        DefectiveQuantity: row.DefectiveQuantity === null ? 0 : row.DefectiveQuantity,
        ConcessionQuantity: row.ConcessionQuantity === null ? 0 : row.ConcessionQuantity,
      }))
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      this.setState({
        rows: nextProps.rows.map(row => ({
          ...row,
          ExcellentQuantity: row.ExcellentQuantity === null ? row.RcvQuantity : row.ExcellentQuantity,
          DefectiveQuantity: row.DefectiveQuantity === null ? 0 : row.DefectiveQuantity,
          ConcessionQuantity: row.ConcessionQuantity === null ? 0 : row.ConcessionQuantity,
        }))
      });
    }
  }

  renderProductTable = () => {
    const IsFixedFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.ProductType === "Non-Fixed") {
          return <span style={{ 'font-weight': 'bold' }}>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
        } else {
          return <span style={{ 'font-weight': 'bold' }}>{this.props.value}</span>;
        }
      }
    });
    const columns = [{
      key: 'ProductNum',
      name: <Translate value="prod_num" />,
      resizable: true,
      sortable: true,
      width: 65,
      filterable: true,
    }, {
      key: 'ProductName',
      name: <Translate value="prod_name" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
    }, {
      key: 'ProductRefNum',
      name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
    }, {
      key: 'PackageSize_1',
      name: <Translate value="package_size" />,
      resizable: true,
      sortable: true,
      width: 85,
      filterable: true
    }, {
      key: 'RcvQuantity',
      name: <Translate value="rcv_qty" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: IsFixedFormatter,
      getRowMetaData: (row) => row,
    }, {
      key: 'RcvTotalWeight',
      name: <Translate value="rcv_weight" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: IsFixedFormatter,
      getRowMetaData: (row) => row,
    }, {
      name: <Translate value="qc_status"/>,
      resizable: true,
      width: 150,
      getRowMetaData: row => row,
      formatter: ({ value, dependentValues }) => {
        if (dependentValues.DefectiveQuantity !== null && dependentValues.DefectiveQuantity !== undefined && dependentValues.DefectiveQuantity !== '') {
          return <div>{dependentValues.ExcellentQuantity + ' / ' + dependentValues.ConcessionQuantity + ' / ' + dependentValues.DefectiveQuantity}</div>
        }
        return <div />
      }
    }, {
      key: 'Remark',
      name: <Translate value="remark" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true
    }, {
      key: 'Note',
      name: <Translate value="note" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true
    }];
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }
    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    }
    const onRowsSelected = (rows) => {
      let newRows = this.state.rows.map(row => ({...row, isSelected: false}));
      rows.map (r => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({rows: newRows, selectedRow: {...rows[0].row, rowIdx: rows[0].rowIdx, isSelected: true}});
    }

    const onRowsDeselected = (rows) => {
      let newRows = this.state.rows;
      rows.map (r => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({rows: newRows, selectedRow: {}});
    }
    return <ReactDataGrid
      rowKey='BatchNum'  
      columns={columns}
      enableCellSelect={true}
      rowGetter={rowGetter}
      headerRowHeight={45}
      rowHeight={25}
      rowsCount={getSize()}
      enableRowSelect='single'
      onRowClick={(index, row) => {
        onRowsSelected([{rowIdx: index, row: {...row, rowIdx: index}}]);
      }}
      rowSelection={{
        showCheckbox: true,
        enableShiftSelect: false,
        onRowsSelected,
        onRowsDeselected,
        selectBy: {
          isSelectedKey: 'isSelected'
        }
      }}
    />
  }

  handleSaveClick = () => {
    const receiveId = this.props.receiveDetails.WarehouseReceive_id;
    axios.put(`${RECEIVE_QC_URL}${receiveId}/`, {
      qc_data_list: this.state.rows.map(row => ({
        ...row,
        ExcellentQuantity: row.ExcellentQuantity || 0,
        DefectiveQuantity: row.DefectiveQuantity || 0,
        ConcessionQuantity: row.ConcessionQuantity || 0,
      }))
    }, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      alert('QC successfully updated!');
      this.props.onClose(true);
    }).catch(err => {
      if (err.status !== 200) {
        alert(err.data || DEFAULT_ERROR)
      }
    });
  }
  
  renderFileUpload = () => {
    const { selectedRow } = this.state;
    const { file_url, file_name } = selectedRow;
    const hasFile = file_name && file_url;
    const hasSelectedRow = !isEmpty(selectedRow);
    const styles = {
      container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      uploaderWrapper: {
        width: 'calc(100% - 20px)',
        height: '80px',
        border: hasSelectedRow && checkPermission('edit_rcv_qc') ? '1px solid #000000' : '1px solid #DCDCDC',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '10px'
      },
      uploader: {
        width: '100%',
        height: '100%',
        opacity: 0,
        position: 'absolute',
        zIndex: '100',
      },
      uploadIcon: {
        fontSize: '44px',
        color: hasSelectedRow && checkPermission('edit_rcv_qc')? '#000000' : '#C5C5C5',
      }
    }
    const handleUpload = ({target: {files}}) => {
      const data = new FormData();
      data.append('File', files[0]);
      this.setState({
        isLoading: true,
      })
      axios.post(MFG_ORDER_UPLOAD, data, {headers: { 'Content-Type': 'multipart/form-data' }}).then(response => {
        if (response.data.url) {
          this.state.rows[selectedRow.rowIdx].file_url = response.data.url;
          this.state.rows[selectedRow.rowIdx].file_name = files[0].name;
          this.state.selectedRow.file_url = response.data.url;
          this.state.selectedRow.file_name = files[0].name;
          this.setState({
            rows: [...this.state.rows],
            selectedRow: {...this.state.selectedRow},
          })
        }
      }).finally(() => this.setState({isLoading: false}));
    }
    const handleDownload = () => {
      window.open(file_url);
    }
    const handleRemove = e => {
      e.stopPropagation();
      this.state.rows[selectedRow.rowIdx].file_url = '';
      this.state.rows[selectedRow.rowIdx].file_name = '';
      this.state.selectedRow.file_url = '';
      this.state.selectedRow.file_name = '';
      this.setState({
        rows: [...this.state.rows],
        selectedRow: {...this.state.selectedRow},
      })
    }
    if (hasFile) {
      return <Col sm={4}>
        <Row onClick={handleDownload}>
          <Col sm={12}>
            <Row style={{marginTop: '10px'}}>
              <Col sm={2}><i className="fa fa-file" style={{fontSize: '20px'}}/></Col>
              <Col sm={9}>{file_name}</Col>
              <Col sm={1} onClick={handleRemove}><i className="fa fa-remove" /></Col>
            </Row>
          </Col>
        </Row>
      </Col>
    }
    return <Col>
      <div id="uploaderWrapper" style={styles.uploaderWrapper}>
        {this.state.isLoading 
          ? <Spinner className="marginTopStyle" /> 
          : <div style={omit(styles.uploaderWrapper, ['border', 'margin'])}>
            <i className={'fa fa-upload'} style={styles.uploadIcon}/>
            <input type={'file'} style={styles.uploader} disabled={!hasSelectedRow || !checkPermission("edit_rcv_qc")} onChange={handleUpload} />
          </div>}
      </div>
    </Col>
  }
  
  render() {
    const handleInputChange = (key, value) => {
      const rowIdx = this.state.selectedRow.rowIdx;
      if (key === 'ConcessionQuantity') {
        if (value > (this.state.selectedRow['RcvQuantity'] - (this.state.rows[rowIdx]['DefectiveQuantity'] || 0) - (this.state.rows[rowIdx]['ExcellentQuantity'] || 0))) {
          return;
        }
      }
      if (key === 'ExcellentQuantity') {
        if (value > (this.state.selectedRow['RcvQuantity'] - (this.state.rows[rowIdx]['DefectiveQuantity'] || 0) - (this.state.rows[rowIdx]['ConcessionQuantity'] || 0))) {
          return;
        }
      }
      if (key === 'DefectiveQuantity') {
        if (value > (this.state.selectedRow['RcvQuantity'] - (this.state.rows[rowIdx]['ExcellentQuantity'] || 0) - (this.state.rows[rowIdx]['ConcessionQuantity'] || 0))) {
          return;
        }
      }
      if(key === 'Note') {
        this.state.rows[rowIdx][key] = value;
        this.state.selectedRow[key] = value;
      } else {
        this.state.rows[rowIdx][key] = +value;
        this.state.selectedRow[key] = +value;
      }
      this.setState({
        rows: [...this.state.rows],
        selectedRow: {...this.state.selectedRow}
      })
    }
    return (
      <ContentWrapper>
        <hr />
        {this.renderProductTable()}
        <br />
        <Row>
          <Col sm={4}>
            <Col sm={4}>
              <label><Translate value="qualified_qty" /></label>
            </Col>
            <Col sm={6}>
              <input
                style={{textAlign: 'center'}}
                className="form-control"
                name="qualified" 
                value={this.state.selectedRow.ExcellentQuantity} 
                disabled={isEmpty(this.state.selectedRow)}
                onChange={({target: {value}}) => {
                  handleInputChange('ExcellentQuantity', value);
                }}
              />
            </Col>
          </Col>
          <Col sm={4}>
            <Col sm={5}>
              <label><Translate value={isVAK ? "concession_qty_new" : "concession_qty"} /></label>
            </Col>
            <Col sm={6}>
              <input
                style={{textAlign: 'center'}}
                className="form-control"
                name="concession"
                value={this.state.selectedRow.ConcessionQuantity}
                disabled={isEmpty(this.state.selectedRow)}
                onChange={({target: {value}}) => {
                  handleInputChange('ConcessionQuantity', value);
                }}
              />
            </Col>
          </Col>
          <Col sm={4}>
            <Col sm={5}>
              <label><Translate value="unqualified_qty" /></label>
            </Col>
            <Col sm={6}>
              <input
                style={{textAlign: 'center'}}
                className="form-control"
                name="unqualified" 
                value={this.state.selectedRow.DefectiveQuantity} 
                disabled={isEmpty(this.state.selectedRow)}
                onChange={({target: {value}}) => {
                  handleInputChange('DefectiveQuantity', value);
                }}
              />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Col sm={4}>
              <label><Translate value="report_file" /></label>
            </Col>
          </Col>
          <Col sm={4}>
            <Col sm={5}>
              <label><Translate value="note" /></label>
            </Col>
            <Col sm={6}>
              <input
                style={{textAlign: 'center', marginTop: '4px'}}
                className="form-control"
                name="Note" 
                value={this.state.selectedRow.Note} 
                disabled={isEmpty(this.state.selectedRow)}
                onChange={({target: {value}}) => {
                  handleInputChange('Note', value);
                }}
              />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            {this.renderFileUpload()}
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm={6}>
            <button
              className="btn btn-primary col-sm-11 buttonStyle"
              onClick={this.handleSaveClick}
              disabled={!checkPermission("edit_rcv_qc")}
            >
              <Translate value="save" />
            </button>
          </Col>
          <Col sm={6}>
            <button className="btn btn-danger col-sm-11 buttonStyle" onClick={() => {this.props.onClose()}}>
              <Translate value="cancel" />
            </button>
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default SetQualityControlModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/setQualityControlModal.jsx